import { createSelector } from '@reduxjs/toolkit';
import { blobUrlStore } from '@ff-os/rendering-react/asset-loading/blobUrlStore';
import { GiftPdpState, GiftPdpStore } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { hasUserInput } from '@gift-variable-plugins/photo-shared/hasUserInput';
import { PhotoVariableInput, ProcessedPhotoInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';

export const startBlobUrlGarbageCollector = (store: GiftPdpStore) => {
    blobUrlStore.startGarbageCollector(() => selectLocalBlobUrls(store.getState()));
};

const selectLocalBlobUrls = createSelector([
    (state: GiftPdpState) => state.project.variables,
    (state: GiftPdpState) => state.project.inputs.entities
], (variables, inputs) => {
    return variables.ids
        .filter(id => variables.entities[id]?.pluginId === 'photo')
        .map(id => inputs[id] as GiftJson.Input<PhotoVariableInput>)
        .filter(isLocalPhoto)
        .map(input => input.value.localUrl) as string[];
});

const isLocalPhoto = (
    input: GiftJson.Input<PhotoVariableInput>
): input is GiftJson.Input<ProcessedPhotoInput> =>
    hasUserInput(input.value) && input.value.processed && input.value.assetSource === 'local';